import { fade, Fade, IconButton, makeStyles, Tooltip } from '@material-ui/core';
import { AttachFile, Cancel } from '@material-ui/icons';
import { Fragment } from 'react';
import { DropzoneArea } from 'material-ui-dropzone';
import { parseCLDR26 } from '../../utils/GridUtils';

const useStyles = makeStyles(theme => ({
  dropZoneWrapper: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
  dropZoneContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    backdropFilter: 'blur(5px)',
    zIndex: theme.zIndex.drawer + 1,
  },
  dropZoneActions: {
    position: 'absolute',
    top: 0,
    right: '1em',
    padding: theme.spacing(1),
    zIndex: theme.zIndex.drawer + 1,
  },
  dropZoneCloseBtn: {
    color: fade(theme.palette.secondary.main, 0.5),
  },
  dropZoneArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    height: '100%',
    width: '100%',
    backgroundColor: fade(theme.palette.primary.main, 0.3),
    padding: theme.spacing(1),
  },
  dropZoneText: {
    fontSize: 12,
  },
}));

const DropZone = ({ children, open, setOpen, handleFiles, maxFileSize, acceptedFiles }) => {
  const classes = useStyles();
  const sizeLimit = maxFileSize || 2;
  const quantityLimit = 1;

  return (
    <Fragment>
      <div style={{ position: 'relative' }}>
        <div className={classes.dropZoneWrapper}>
          <Fade in={open} appear={false} timeout={300} unmountOnExit>
            <div className={classes.dropZoneContainer}>
              <div className={classes.dropZoneActions}>
                <Tooltip title={'Cancelar carga de archivo'} enterDelay={1000}>
                  <IconButton className={classes.dropZoneCloseBtn} aria-label="cancelDropZone" size="small" onClick={() => setOpen(false)}>
                    <Cancel />
                  </IconButton>
                </Tooltip>
              </div>
              <DropzoneArea
                filesLimit={quantityLimit}
                maxFileSize={1024 * 1024 * sizeLimit}
                acceptedFiles={acceptedFiles}
                Icon={AttachFile}
                dropzoneText="Arrastre y suelte un archivo en esta zona o haga click para abrir un cuadro de búsqueda"
                dropzoneParagraphClass={classes.dropZoneText}
                dropzoneClass={classes.dropZoneArea}
                showPreviewsInDropzone={false}
                onDrop={handleFiles}
                getDropRejectMessage={() => {
                  const fileSize = maxFileSize && (Number.isInteger(maxFileSize) ? maxFileSize : parseCLDR26(maxFileSize));
                  const conditions = [`No supere los ${fileSize || sizeLimit} MB`];
                  acceptedFiles &&
                    conditions.push(`El formato sea ${acceptedFiles.map(ext => ext.split('/')[1].toUpperCase()).join(', ')}`);

                  return (
                    <div>
                      No se puede adjuntar archivo. Verifique que el mismo cumpla con las siguientes condiciones:<br></br>
                      <ul>
                        {conditions.map(cond => (
                          <li>{cond}</li>
                        ))}
                      </ul>
                    </div>
                  );
                }}
                getFileLimitExceedMessage={() => `Cantidad máxima de archivos a soltar en el recuadro: ${quantityLimit}`}
              />
            </div>
          </Fade>
        </div>
        {children}
      </div>
    </Fragment>
  );
};

export default DropZone;
